import React from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import { css } from "@emotion/css";
import "../../styles/main.scss";

interface IBCLoader {
  size?: "mini" | "tiny" | "small" | "medium" | "large" | "big" | "huge" | "massive",
  height?: number,
  isDisplayedInModal?: boolean
}

const BCLoader = (props: IBCLoader) => {
  const { size = "big", height = 400 } = props;
  const loaderStyles = css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: ${height}px;
  `;

  return <div className={loaderStyles}>
    <Dimmer active inverted>
      <Loader active inline="centered" size={size} />
    </Dimmer>
  </div>;
};

export default BCLoader;